import { Lessons } from '../generated/Lessons';
import { Teacher } from '../generated/Teacher';
import { ShiftTable } from '../generated/ShiftTable';

export class LessonScheduleDTO {
  teacher?: Teacher;
  shiftTable?: ShiftTable;
  lesson?: Lessons;
}
